<template>
  <div class="vm-images">
    <v-text-field
      class="font-size-sm form-control search-text-field mb-3"
      :placeholder="$t('global.search')"
      prepend-icon="search"
      v-model="search"
      single-line
      dense
      flat
      solo
      hide-details
    ></v-text-field>

    <div class="list">
      <List
        :header="header"
        :data="getData"
        :loading="loading"
        @click="clickField"
      >
        <template v-slot:item.name="{ item }">
          {{
            $customFunctions.upperFirstLetter(
              `${item.os ? item.os + ' ' : ''}${
                item.distro ? item.distro + ' ' : ''
              }${item.version ? item.version + ' ' : ''}${
                item.cpu_type ? item.cpu_type + ' ' : ''
              }`
            )
          }}
        </template>
      </List>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'

export default {
  name: 'VMImages',
  props: {
    dcNodeId: String | Number,
  },
  data() {
    return {
      loading: false,
      header: [{ text: 'servers.vmName', value: 'name', clicked: true }],
      data: [],
      search: '',
    }
  },
  computed: {
    getData() {
      return this.data.filter((f) =>
        `${f.os ? f.os + ' ' : ''}${f.distro ? f.distro + ' ' : ''}${
          f.version ? f.version + ' ' : ''
        }${f.cpu_type ? f.cpu_type + ' ' : ''}`
          .toLowerCase()
          .includes(this.search.toLowerCase())
      )
    },
  },
  created() {
    this.getRepoImages()
  },
  methods: {
    getRepoImages() {
      this.getRepoImagesList()
        .then((res) => {
          this.setRepoImagesList(res)
        })
        .catch(() => {
          this.data = []
        })
    },
    getRepoImagesList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `repo/images?datacenterNode=${this.dcNodeId}&position=id|desc`
        )
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setRepoImagesList(res) {
      if (res && res.data && res.data.length > 0) {
        this.data = res.data
      }
    },
    clickField(item) {
      this.$emit('selectedItem', item)
      this.$emit('closeSecondModal', false)
    },
  },
}
</script>

<style lang="scss">
.vm-images {
  .list {
    margin-bottom: 20px;

    .color-blue {
      color: #00baf2;
    }
  }
}
</style>
